module.exports = __webpack_public_path__ + "img/collection-weddingRingsStylesCreative@2x.b8e7377.webp";